<template>
  <v-container>
    <v-layout v-if="formload" row wrap>
      <v-flex text-md-center>
        <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
      </v-flex>
    </v-layout>
    <v-flex v-else>
      <highcharts :options="chartoptions" ref="highcharts"></highcharts>
    </v-flex>
    <faqs></faqs>
  </v-container>
</template>
<script>
import loadMap from 'highcharts/modules/map.js';
import Highcharts from 'highcharts';
import { genComponent } from 'vue-highcharts'
import { mapGetters } from "vuex";
import Faqs from "@/components/Faqs";

loadMap(Highcharts)

export default {
  props: ["user"],
  components: {
    Faqs,
    Highcharts: genComponent('Highcharts', Highcharts)
  },
  computed: {
    ...mapGetters(["getTokenHeader", "getServer", "getUserId", "getColor"])
  },
  data() {
    return {
      formload: true,
      chartoptions: {
        chart: {
          type: "area"
        },
        title: {
          text: ""
        },
        subtitle: {
          text: ""
        },
        xAxis: {
          categories: []
        },
        yAxis: {
          allowDecimals: false,
          title: {
            text: "Requests"
          },
          plotLines: [
            {
              value: 0,
              width: 1,
              color: "#808080"
            }
          ]
        },
        series: [
          {
            name: "Requests",
            data: [],
            color: "#27408b"
          }
        ],
        credits: false
      },
      days: 7
    };
  },
  created() {
    const userid = this.user ? parseInt(this.user, 0) : this.getUserId;
    this.$http
      .get(
        `${this.getServer}/users/${userid}/stats?days=${this.days}`,
        this.getTokenHeader
      )
      .then(data => {
        if (data.data && data.data.retorn && data.data.dates) {
          var series = Object.keys(data.data.retorn).map(api => {
            var color = this.getColor[api];
            var api_name = ''
            if(api==='DIGITAL') api_name = 'Digital'
            else if(api==='digital') api_name = 'Digital'
            else if(api==='YOUTUBE') api_name = 'YouTube'
            else if(api==='youtube') api_name = 'YouTube'
            else if(api==='Youtube') api_name = 'YouTube'
            else if(api==='INSTAGRAM') api_name = 'Instagram'
            else if(api==='instagram') api_name = 'Instagram'
            else if(api==='FACEBOOK') api_name = 'Facebook'
            else if(api==='facebook') api_name = 'Facebook'
            else if(api==='TWITTER') api_name = 'Twitter'
            else if(api==='twitter') api_name = 'Twitter'
            else if(api==='LAW') api_name = 'Law'
            else if(api==='law') api_name = 'Law'
            else if(api==='NEWSPRO') api_name = 'NewsPro'
            else if(api==='newspro') api_name = 'NewsPro'
            else if(api==='TIKTOK') api_name = 'TikTok'
            else if(api==='tiktok') api_name = 'TikTok'
            else api_name = api
            return {
              name: api_name,
              data: data.data.retorn[api],
              color
            };
          });

          this.chartoptions = {
            chart: {
              type: "line"
            },
            title: {
              text: "",
              x: -20
            },
            subtitle: {
              x: -20
            },
            xAxis: {
              categories: data.data.dates
            },
            yAxis: {
              allowDecimals: false,
              title: {
                text: "Requests"
              }
            },

            series,
            credits: false
          };
          this.formload = false;
        }
      });
  }
};
</script>
